var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSuclReg(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "svg-icon",
    style: {
      width: "1.0810546875em",
      height: "1em",
      verticalAlign: "middle",
      fill: "currentColor",
      overflow: "hidden"
    },
    viewBox: "0 0 1107 1024",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M553.331988 1023.311134C248.115579 1023.311134 0.688866 794.389097 0.688866 512 0.688866 229.610903 248.115579 0.688866 553.331988 0.688866 858.548397 0.688866 1105.975109 229.610903 1105.975109 512 1105.975109 794.389097 858.548397 1023.311134 553.331988 1023.311134ZM900.022291 375.776657 829.208196 295.863669C826.684879 293.016239 820.910455 294.01234 816.310894 298.088363L497.61509 580.497092 321.49639 430.93695C317.624616 427.64899 312.490839 427.334867 310.029863 430.235339L244.529684 507.436949C242.069053 510.337421 243.212572 515.354091 247.084346 518.64205L497.006821 730.876297C500.878595 734.163913 506.012028 734.478036 508.473004 731.577563L508.711007 731.29685C509.655099 730.745068 510.587479 730.074112 511.475773 729.287082L896.262114 388.312993C900.86202 384.236626 902.545609 378.624086 900.022291 375.776657Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuclReg);
export default __webpack_public_path__ + "static/media/suclReg.9c80c67ecfdd093bb2e6180d9743a99e.svg";
export { ForwardRef as ReactComponent };